import { ErrorHandler, Inject, NgZone } from "@angular/core";
import { ToastyService } from "ng2-toasty";

export class AppErrorHandler implements ErrorHandler {

    constructor(
        @Inject(NgZone) private ngZone: NgZone,
        @Inject(ToastyService) private toastyService: ToastyService) {

    }

    handleError(error: any): void {
        this.ngZone.run(() => {
            console.log("ERROR:" + error);
            if (typeof (window) !== 'undefined') {
                this.toastyService.error({
                    title: "Error",
                    msg: 'An unexpected error occured',
                    theme: 'bootstrap',
                    showClose: true,
                    timeout: 5000
                });
            }
        });


    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/app.error-handler.ts